import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Search from './pages/Search';
import PatientDetail from './pages/PatientDetail';
import PatientCreate from './pages/PatientCreate';
import Prescription from './pages/Prescription';
import NavBar from './components/Nav';
import Daily from './pages/Daily';
import Login from './pages/Login';
import Recipe from './pages/Recipe';
import Medicines from './pages/Medicines';
import Services from './pages/Services';
import PatientService from './pages/PatientService';
import Report from './pages/Report';

function App() {
	const token = localStorage.getItem('token');
	if (!token && window.location.pathname !== '/login') {
		// handle auth	 at top level
		window.location.href = '/login';
	}

	return (
		<div className="rtl">
			<NavBar />
			<Router>
				<Switch>
					<Route path="/login">
						<Login />
					</Route>

					<Route path="/next">
						<PatientDetail />
					</Route>
					<Route path="/daily">
						<Daily />
					</Route>
					<Route path="/history">
						<Daily history />
					</Route>
					<Route path="/patient/create">
						<PatientCreate />
					</Route>
					<Route path="/patient/create/:id">
						<PatientCreate />
					</Route>
					<Route path="/patient/:id/create">
						<Prescription />
					</Route>
					<Route path="/patient/:id/recipe/:recipeId">
						<Recipe />
					</Route>
					<Route path="/patient/:id/recipe">
						<Recipe />
					</Route>
					<Route path="/patient/:id/service">
						<PatientService />
					</Route>

					<Route path="/patient/:id/prescription/:visit">
						<Prescription />
					</Route>
					<Route path="/patient/:id">
						<PatientDetail />
					</Route>
					<Route path="/medicines">
						<Medicines />
					</Route>
					<Route path="/services">
						<Services />
					</Route>
					<Route path="/report">
						<Report />
					</Route>

					<Route path="/">
						<Search />
					</Route>
				</Switch>
			</Router>
		</div>
	);
}

export default App;
